module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [(this.$route.params.id) ? _c('submenu') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options-list"
  }, _vm._l((_vm.paymentOptions), function(option) {
    return _c('div', {
      staticClass: "options-list__item"
    }, [_c('div', {
      staticClass: "options-list__content"
    }, [_c('h2', {
      staticClass: "options-list__title"
    }, [_vm._v(_vm._s(option.name))])]), _vm._v(" "), _c('div', {
      staticClass: "options-list__control",
      attrs: {
        "data-acc": "toggle"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentPaymentOptions),
        expression: "currentPaymentOptions"
      }],
      staticClass: "options-list__checkbox",
      attrs: {
        "data-acc": "input",
        "id": option.id,
        "type": "checkbox"
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.currentPaymentOptions) ? _vm._i(_vm.currentPaymentOptions, option.id) > -1 : (_vm.currentPaymentOptions)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(option.id)
        },
        "change": function($event) {
          var $$a = _vm.currentPaymentOptions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentPaymentOptions = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentPaymentOptions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentPaymentOptions = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "options-list__toggle",
      attrs: {
        "for": option.id
      }
    })])])
  }), 0)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1baec13f!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/groups/GroupPaymentOptions.vue
// module id = 715
// module chunks = 1